/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Broker_Photo_MissingInputs */

const cs_draft_broker_photo_missing = /** @type {(inputs: Draft_Broker_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřazený makléř nemá avatar. Katalogy ho vynechají, dokud ho nepřidáte.`)
};

const en_draft_broker_photo_missing = /** @type {(inputs: Draft_Broker_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No avatar on the assigned broker’s profile. Catalogs will omit it until one is uploaded.`)
};

/**
* | output |
* | --- |
* | "No avatar on the assigned broker’s profile. Catalogs will omit it until one is uploaded." |
*
* @param {Draft_Broker_Photo_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_broker_photo_missing = /** @type {((inputs?: Draft_Broker_Photo_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Broker_Photo_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_broker_photo_missing(inputs)
	return cs_draft_broker_photo_missing(inputs)
});